import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './OurStoryPage.css';

const OurStoryPage = () => {
  return (
    <div className="our-story-page">
      <Header showSearch={false} />
      <main className="story-content">
        <article className="story-article">
          <h1 className="story-title">Our Story</h1>
          
          <p className="story-subtitle">
            It's time to build a smarter, more human way to learn—without distractions.
          </p>

          <section className="story-section">
            <p className="story-text">
              Have you ever looked up a word online, only to be hit with pop-ups, autoplay videos, and walls of confusing definitions? 
              <strong> Most dictionaries today aren't built to help you learn—they're designed to keep you scrolling. </strong> 
              That cluttered, ad-heavy experience can actually make it harder to understand and remember new words.
            </p>
          </section>

          <section className="story-section">
            <p className="story-text">
              Traditional vocabulary tools haven't evolved much either. Flashcards and drills might help you pass a test, but 
              <strong> they rarely teach you how to speak, write, or create with confidence. </strong> 
              In the age of AI, it's time to move beyond memorization—and toward meaningful, real-world language use.
            </p>
          </section>

          <section className="story-section">
            <p className="story-text">
            I’ve felt these frustrations myself—first as a language learner, then as someone building educational tools. When my last company prioritized ad revenue over real learning and let me go, I decided to build something better.
            I wanted to create  <strong>a tool that helps you truly understand words, use them with confidence, and actually enjoy the process.</strong>
            </p>
          </section>

          <section className="story-section">
            <p className="story-text">
              I started this journey without much programming background—just purpose, persistence, and the help of AI. 
              Learning isn't always easy, but with thoughtful design and the right tools, it can be joyful, powerful, and deeply human.
            </p>
          </section>

          <section className="story-section">
            <p className="story-text">
              This platform is the result. A clean, ad-free, context-aware learning experience—powered by AI, guided by personas, and built with care. 
              Everything here exists to help you learn better, not just faster.
            </p>
          </section>

          <section className="story-section">
            <p className="story-text">
              If this vision resonates with you, we'd love your support—whether that means sharing feedback, helping us grow, 
              or simply learning with us. This is just the beginning.
            </p>
          </section>

          <div className="story-cta">
            <h2 className="cta-text">Let's make learning better—together.</h2>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default OurStoryPage; 